import { ShieldAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { EmptyState } from '../../components/EmptyState';
import { useAuth } from './AuthProvider';

/** Renders children only for principals holding `permission`. UI gating only. */
export function RequirePermission({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
}) {
  const { can } = useAuth();
  if (can(permission)) return children;
  // Operators (monitoring-only, no full live access) have no other pages: send
  // them back to /monitoring instead of a dead-end "access denied" (ADR-038).
  if (permission !== 'monitoring.view' && can('monitoring.view') && !can('live.view')) {
    return <Navigate to="/monitoring" replace />;
  }
  return (
    <EmptyState
      icon={ShieldAlert}
      tone="crit"
      title="Acesso negado"
      description="Você não tem permissão para acessar esta área. Fale com o administrador da organização."
    />
  );
}
